import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { loadCountryPhoneCodes } from 'src/actions/company/companyTarget';

import FormGroup from '../../helpers/FormGroup';
import BaseInput from '../../helpers/Input';
import BaseSelect from '../../helpers/Select';
import { unwrap } from '../../../utils/ChangeSpy';
import PrettyError from '../../decorators/PrettyError';
import ErrorDisplay from '../../decorators/DisplayError';
import Button from '../../helpers/Button';

import style from './style.module.css';

const Input = PrettyError(ErrorDisplay(BaseInput));
const Select = PrettyError(ErrorDisplay(BaseSelect));

const PhoneFormComponent = ({ event, onCall, onChange }) => {
  const phoneCodes = useSelector(state => state.targetCompany.target.get('phoneCodes'));
  const dispatch = useDispatch();

  useEffect(() => {
    if (!phoneCodes.size) {
      dispatch(loadCountryPhoneCodes());
    }
  }, []);

  const handleCall = () => {
    const phoneNumber = unwrap(event.get('phone')).replaceAll('-', '');
    const phoneCode = unwrap(event.get('phoneCode'));
    const eventId = event.get('id');

    onCall(phoneNumber, phoneCode, eventId);
  };

  const isNewEvent = Boolean(event.get('id')) === false;
  const disabledCall = !(unwrap(event.get('phone')) && unwrap(event.get('phoneCode'))) || isNewEvent;

  return (
    <>
      <FormGroup className="col-xs-3">
        <Input
          className="input-md"
          label="Country Code"
          maxLength="10"
          name="phoneCode"
          placeholder="Country Code"
          root={event}
          deep
          disabled
          showLabel
        />
      </FormGroup>
      <FormGroup className="col-xs-5">
        <label className="field-label" htmlFor="event-phone">
          Phone{' '}
          {isNewEvent && (
            <span
              className={classNames(style.callWarningIcon, 'fa fa-info-circle')}
              title="To make a call, please save the event first"
            />
          )}
        </label>
        <div className="input-group">
          <Input
            className="input-md"
            id="event-phone"
            label="Phone"
            maxLength="50"
            name="phone"
            onChange={onChange}
            placeholder="Phone"
            root={event}
            deep
          />
          <span className="input-group-btn">
            <Button disabled={disabledCall} onClick={handleCall}>
              <i className="fa fa-phone mr5" />
              Call
            </Button>
          </span>
        </div>
      </FormGroup>
      <FormGroup className="col-xs-4">
        <Select
          className="input-md"
          label="Country"
          name="country"
          nameKey="name"
          onChange={onChange}
          options={phoneCodes}
          placeholder="Country"
          root={event}
          valueKey="code"
          deep
          showLabel
        />
      </FormGroup>
    </>
  );
};

/** Phone form component. */
export const PhoneForm = memo(PhoneFormComponent);
